// store/index.js
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoggedIn: false,
  },
  mutations: {
    setLoginStatus(state, status) {
      state.isLoggedIn = status;
    },
    setUserInfo(state, payload) {
      state.userInfo = payload || {};
    },
  },
  actions: {
    logout({ commit }) {
      commit("setLoginStatus", false);
    },
  },
});
